import { typography } from "@dsaui/components";
import { cn } from "packages/dsaui/src/utils";

export const PageTitle = ({
  children,
  className,
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => (
  <h1
    className={cn(
      typography.formPageTitle.className,
      "px-4 text-center lg:px-0",
      className,
    )}
  >
    {children}
  </h1>
);
